import React from 'react'

export default function UtilitiesHeaderStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
      `}
      </style>
    </React.Fragment>
  )
}
